import styled from "styled-components";

import { theme } from "../../configuration";

const HelpResultCardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  
  @media (max-width: ${theme.pageWidthForSingleColumnHelpResults}) {
    display: block;
  }
`;

export default HelpResultCardContainer;
